import PropTypes from 'prop-types'
import React,
{ Component } from 'react'
import { connect } from 'react-redux'

import {
  Button,
  Flex 
} from '@driftt/dds'
import {
  Footer,
  H3,
  Input,
  Modal,
  P 
} from '@driftt/tide-core'
import { showTransientNotification } from '@driftt/traffic-control'
import { suggestImportSource } from 'api/imports'

const MINIMUM_LOADING_TIME = 1000

class ImportSourceSuggestionModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isSubmitting: false,
      suggestionValue: '',
    }
  }

  submitSuggestion = async (suggestion) => {
    await Promise.all([
      suggestImportSource({ suggestion }),
      new Promise(resolve => window.setTimeout(resolve, MINIMUM_LOADING_TIME))
    ])
  }

  showSuccessNotification = () => {
    this.props.showTransientNotification({ 
      type: 'success',
      message: 'Thanks, we’ve received your suggestion!'
    })
  }

  handleSubmitSuggestion = async () => {
    const { suggestionValue } = this.state

    this.setState({ isSubmitting: true })

    await this.submitSuggestion(suggestionValue)

    this.setState({
      isSubmitting: false,
      suggestionValue: ''
    })

    this.showSuccessNotification()
    this.props.onClose()
  }

  handleSuggestionChange = (event) => {
    this.setState({ suggestionValue: event.target.value })
  }

  render() {
    const {
      isOpen,
      onClose 
    } = this.props
    const {
      suggestionValue,
      isSubmitting 
    } = this.state

    return (
      <Modal
        open={isOpen}
        onClose={onClose}
        size="small"
      >
        <H3>Suggest import source</H3>
        <P>What source would you like to import your contacts from?</P>
        <Input 
          type="text" 
          placeholder="Import source…"
          value={suggestionValue}
          onChange={this.handleSuggestionChange}
          disabled={isSubmitting}
        />
        <Footer>
          <Flex>
            <Button onClick={this.handleSubmitSuggestion}
              loading={isSubmitting}>
              Suggest source
            </Button>
            <Button variant="secondary" onClick={onClose}
              loading={isSubmitting}>
              Cancel
            </Button>
          </Flex>
          
        </Footer>
      </Modal>
    )
  }
}

ImportSourceSuggestionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

const mapDispatchToProps = dispatch => {
  return {
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

export default connect(null, mapDispatchToProps)(ImportSourceSuggestionModal)
